module.exports = __webpack_public_path__ + "img/k-1-hover.606b42cd.png";